import { Injectable } from '@angular/core';
import { DropDownModel } from 'app/modules/common/entities/DropDownModel';
import { Criteria, Rule, RuleType } from 'app/modules/common/entities/leave-import/criteria.model';
import { RestResponse } from 'app/modules/common/entities/rest.response.generic.model';
import { ApiService } from 'app/modules/common/services/api.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import API from '../../common/services/api.config.json';

@Injectable({
    providedIn: 'root'
})
export class LeaveImportRulesService {

    private _criterias = new BehaviorSubject<DropDownModel[]>([]);
    /**
     * Subscribe to criterias. If this service is properly used, every change in criterias list will be notified from
     * this `subject`
     */
    public get criterias(): BehaviorSubject<DropDownModel[]> {
        return this._criterias;
    }


    constructor(
        private apiService: ApiService,
    ) {
        // update task criterias
        this.updateTaskCriteriasList();
    }



    //#region CRITERIA

    /**
       * Update the task criterias and emit `criterias` subject
       */
    public updateTaskCriteriasList(): void {
        const url = API.LeaveImport.commonCriteriaEndPoint;
        this.apiService
            .get(url)
            .subscribe((res: RestResponse<DropDownModel[]>) => {
                if (res.code === 0)
                    this._criterias.next(res.result);
                else
                    this._criterias.error(res.message ?? res);
            }, err => {
                return this._criterias.error(err);
            });
    }


    /**
     * Create a criteria
     */
    public createCriteria(criteria: Criteria): Observable<RestResponse<Criteria>> {
        const url = API.LeaveImport.commonCriteriaEndPoint;
        return this.apiService
            .post(url, criteria)
            .pipe(
                tap(() => this.updateTaskCriteriasList())
            );
    }


    /**
     * Update a criteria
     */
    public updateCriteria(criteriaId: number, criteria: Criteria): Observable<RestResponse<Criteria>> {
        const url = `${API.LeaveImport.commonCriteriaEndPoint}/${criteriaId}`;
        return this.apiService
            .put(url, criteria)
            .pipe(
                tap(() => this.updateTaskCriteriasList())
            );
    }


    /**
     * Delete a criteria
     */
    public deleteCriteria(criteriaId: number): Observable<RestResponse<null>> {
        const url = `${API.LeaveImport.commonCriteriaEndPoint}/${criteriaId}`;
        return this.apiService
            .delete(url)
            .pipe(
                tap(() => this.updateTaskCriteriasList())
            );
    }

    //#endregion



    //#region RULES

    /**
     * Get rule types
     */
    public getRuleTypes(): Observable<RestResponse<RuleType[]>> {
        const url = (API.LeaveImport.getRuleTypes as string);
        return this.apiService.get(url);
    }


    /**
    * Get rules of a criteria
    */
    public getRules(criteriaId: number): Observable<RestResponse<Rule[]>> {
        const url = (API.LeaveImport.getRules as string)
            .replace("{id}", criteriaId.toString());
        return this.apiService.get(url);
    }


    /**
    * Create a rule
    */
    public createRule(rule: Rule): Observable<RestResponse<Rule>> {
        const url = API.LeaveImport.commonRulesEndPoint as string;
        return this.apiService.post(url, rule);
    }


    /**
    * Create a rule
    */
    public updateRule(ruleId: number, rule: Rule): Observable<RestResponse<Rule>> {
        const url = `${API.LeaveImport.commonRulesEndPoint}/${ruleId}`;
        return this.apiService.put(url, rule);
    }


    /**
    * Delete a rule
    */
    public deleteRule(ruleId: number): Observable<RestResponse<null>> {
        const url = `${API.LeaveImport.commonRulesEndPoint}/${ruleId}`;
        return this.apiService.delete(url);
    }

    //#endregion

}
